import {Navigate} from 'react-router';

import App from '@src/App';

import type {RouteConfig} from './types';

import {chatsRoutes} from './chats';
import {contentRoutes} from './content';
import {crmRoutes} from './crm';
import {foodDiaryRoutes} from './food-diary';
import {miscRoutes} from './misc';
import {routerPath} from './path';
import {practiceRoutes} from './practice';
import {profileRoutes} from './profile';
import {publicRoutes} from './public';
import {questionnairesRoutes} from './questionnaires';
import {todosRoutes} from './todos';
import {protectRoutes} from './utils';
import {yourSpaceRoutes} from './your-space';

const routes = [
  {
    children: [
      {
        element: <Navigate to={routerPath.yourSpace.$path()} />,
        path: routerPath.$path(),
      },
      ...yourSpaceRoutes,
      ...profileRoutes,
      ...chatsRoutes,
      ...crmRoutes,
      ...miscRoutes,
      ...practiceRoutes,
      ...todosRoutes,
      ...contentRoutes,
      ...questionnairesRoutes,
      ...foodDiaryRoutes,
      ...publicRoutes,
    ],
    element: <App />,
    isPublic: true,
  },
] satisfies RouteConfig[];

export const appRoutes = protectRoutes(routes);
